// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

export { default } from './Paragraph';



// WEBPACK FOOTER //
// ./components/Paragraph/index.js